import gql from 'graphql-tag'

export const GET_LEARNING_CENTERS_AND_UNITS = gql`
  query getLearningCentersAndUnits($StudentId: String!, $region: String!) {
    getLearningCenters(StudentId: $StudentId) {
      Id
      Preferred
      Phone
      Name
      Address
      Instructors {
        Name
        Preferred
        Id
      }
    }
    getUnits(region: $region) {
      Unit {
        Unit
        Minutes
        Default
      }
    }
  }
`

export const GET_LC_HOLIDAYS = gql`
  query GetLCHolidays($StartDateTime: String!, $EndDateTime: String!, $LearningCenterId: String!, $Country: String!) {
    getLCHolidays(
      StartDateTime: $StartDateTime
      EndDateTime: $EndDateTime
      LearningCenterId: $LearningCenterId
      Country: $Country
    ) {
      Holidays {
        holidayInfo {
          StartDateTime
          EndDateTime
        }
      }
    }
  }
`
